import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  createCustomer,
  getCustomerList,
  getCustomers,
} from "../../api/customer";
import { handleAxiosError } from "../../config/action-config";
import { subCustomerTable as tableDef } from "../../config/grid-columns-defs";
import ControlledTable from "../../component/ControlledTable";
import CreateDialog from "../../component/CreateDialog";
import { showAlert } from "../../actions/alert";
import { createSubCustomers, getSubCustomers } from "../../api/subCustomers";
import { useForm, Controller } from "react-hook-form";
import { capitalizeFirstLetter } from "../../config/grid-value-formatters";

const emptyNewCustomerData = {
  email: "",
  firstname: "",
  lastname: "",
  address: "",
  password: "",
  contact: "",
  // status: "",
  master_user: "",
};

export default function SubCustomer() {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [newCustomerData, setNewCustomerData] = useState(emptyNewCustomerData);
  const [customersList, setCustomersList] = useState([]);

  useEffect(() => {
    customerList();
  }, []);

  const onNewSubCustomerSubmit = (data) => {
    // createSubCustomers(newCustomerData, user.token)
    createSubCustomers(data, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        reset();
        setNewCustomerData(emptyNewCustomerData);
        refreshTable();
        setCreateDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setCreateDialogOpen(false);
      });
  };

  const refreshTable = () => {
    getSubCustomers({ limit: 10, offset: 0, sort: "creation_date" }, user.token)
      .then((res) => {
        setTotalCount(
          parseInt(res.data.total) === 0 ? -1 : parseInt(res.data.total)
        );
        setRows(res.data.data);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const getRows = async (numRows, startRow) => {
    return getSubCustomers(
      { limit: numRows, offset: startRow, sort: "creation_date" },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.data;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const changeNewCustomerData = (e) => {
    setNewCustomerData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const customerList = async () => {
    const token = user.token;
    return await getCustomerList(token).then((res) => {
      setCustomersList(res.data.data);
    });
  };

  useEffect(() => {
    if (!createDialogOpen) {
      reset();
      // setNewCustomerData(emptyNewCustomerData);
    }
  }, [createDialogOpen]);

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Sub Users
          </Typography>
        </Box>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add Sub User
        </Button>
      </Box>
      <br />
      <ControlledTable
        rows={rows}
        columnDefs={tableDef}
        getRows={getRows}
        totalCount={totalCount}
        onChange={setRows}
        onPageNumberChange={setPageNumber}
        pageSize={10}
        pageNumber={pageNumber}
        pagination={true}
        getRowNodeId={({ data }) => data?.id || data?.name}
        hasActionButtons={false}
      />
      <CreateDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onSubmit={handleSubmit(onNewSubCustomerSubmit)}
      >
        <form onSubmit={handleSubmit(onNewSubCustomerSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl
                fullWidth
                margin="dense"
                required
                error={Boolean(errors.master_user)}
              >
                <InputLabel id="demo-simple-select-label">Customer</InputLabel>

                <Controller
                  render={(props) => {
                    let selectValue = props.value;

                    // Check if the customersList has only one item
                    if (customersList.length === 1 && !selectValue) {
                      // Set the value to the ID of the only item
                      selectValue = customersList[0].id.toString();
                      // Trigger the form validation manually since the value is updated programmatically
                      props.onChange(selectValue);
                    }

                    return (
                      <Select value={selectValue} onChange={props.onChange}>
                        {customersList.map((c, i) => (
                          <MenuItem key={i} value={c.id.toString()}>
                            {capitalizeFirstLetter(c.company_name)}
                          </MenuItem>
                        ))}
                      </Select>
                    );
                  }}
                  name="master_user"
                  control={control}
                  rules={{
                    required: "Please choose Customer",
                  }}
                />
                <FormHelperText>{errors.master_user?.message}</FormHelperText>
              </FormControl>

              {/* <FormControl margin="dense" required fullWidth>
                <InputLabel id="demo-simple-select-label-a">
                  Customer
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label-a"
                  id="demo-simple-select-a"
                  value={newCustomerData.master_user}
                  label="Customer"
                  name="master_user"
                  onChange={(event) => {
                    let selectedCustomer = customersList.find((s) => {
                      return s.id === event.target.value;
                    });

                    changeNewCustomerData({
                      target: {
                        name: "master_user",
                        value: selectedCustomer.id.toString(),
                      },
                    });
                  }}
                >
                  {customersList.map((c, i) => (
                    <MenuItem key={i} value={c.id}>
                      {c.firstname}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="email"
                fullWidth
                // value={newCustomerData.email}
                // onChange={changeNewCustomerData}
                label="Email"
                type="email"
                variant="outlined"
                inputRef={register({
                  required: "Email Address  is required.",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                required
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="password"
                fullWidth
                // value={newCustomerData.password}
                // onChange={changeNewCustomerData}
                label="Password"
                type="password"
                variant="outlined"
                inputRef={register({
                  required: "Password is required.",
                  validate: (value) =>
                    value.length > 4 || "Password is not valid",
                })}
                required
                error={Boolean(errors.password)}
                helperText={errors.password?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="firstname"
                fullWidth
                // value={newCustomerData.firstname}
                // onChange={changeNewCustomerData}
                label="First Name"
                className="name-textfeild"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "First Name is required.",
                })}
                required
                error={Boolean(errors.firstname)}
                helperText={errors.firstname?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="lastname"
                fullWidth
                // value={newCustomerData.lastname}
                // onChange={changeNewCustomerData}
                label="Last Name"
                className="name-textfeild"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                })}
                // error={Boolean(errors.lastname)}
                // helperText={errors.address?.lastname}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="contact"
                fullWidth
                // value={newCustomerData.contact}
                // error={!/^[0-9]{10}$/.test(newCustomerData.contact)}
                inputProps={{ maxLength: 10 }}
                // onChange={changeNewCustomerData}
                label="Contact"
                type="tel"
                variant="outlined"
                inputRef={register({
                  required: "Contact Number is required.",
                  validate: (value) =>
                    value.length > 9 || "Please enter a valid number",
                })}
                required
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                margin="dense"
                name="address"
                fullWidth
                // value={newCustomerData.address}
                // onChange={changeNewCustomerData}
                label="Address"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Address is required.",
                })}
                required
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
              />
            </Grid>
          </Grid>
        </form>
      </CreateDialog>
    </Box>
  );
}
